/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import { push } from 'connected-react-router';
import MenuIcon from '@components/portal/menu/icon';
import OverflowTooltipableLabel from '@shared/overflow-tooltipable-label';
import { getDataType, getPortalPath } from '@utils/dashboard-utils';
import { verifyPermissions } from '@utils/permission-utils';
import './menu-section.scss';

const MenuSectionItem = ({
  item: {
    // children,  // This property is unused for now
                  // (we'll use the 'children' one when we make this component
                  // to render overlaps, i.e. a data type with subtypes).
    icon, label, permissions, subtype, type
  }
}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const params = useParams();
  const { dataType } = params || {};

  const portal = getPortalPath();
  const subTypeField = subtype ? `/${subtype}` : '';
  const onClick = useCallback(
    () => dispatch(push(`/${portal}/data/${type}${subTypeField}`)),
    [dispatch, portal, subTypeField, type]
  );

  if (!verifyPermissions(permissions)) {
    return null;
  }

  const topLevelDataType = getDataType({ dataType }, location);
  const active = subtype ? subtype === dataType && topLevelDataType === type : type === topLevelDataType;

  return (
    <div
      onClick={onClick}
      role="presentation"
      styleName={active ? 'menu-item active' : 'menu-item'}
    >
      {icon && (
        <span styleName="menu-icon">
          <MenuIcon icon={icon} type={subtype} active={active} />
        </span>
      )}
      <OverflowTooltipableLabel>{label}</OverflowTooltipableLabel>
    </div>
  );
};

MenuSectionItem.propTypes = {
  item: PropTypes.object
};

export default MenuSectionItem;
